import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { KIOSK_COMMUNICATION_EVENT_TYPES } from "models";

import type { KioskCommunicationEvent } from "models";

type SignatureProps = {
  events?: KioskCommunicationEvent[];
};

export const Signature = ({ events }: SignatureProps) => {
  if (!events?.length) return null;

  const event = events.find(e => e.type === KIOSK_COMMUNICATION_EVENT_TYPES.CheckInAnswered);
  const { t } = useTranslation();

  if (!event?.customer_signature) return null;

  return (
    <div className="kiosk-comm-section-container">
      <div className="kiosk-comm-section-header">{t("v8_signature", "Signature")}</div>

      <Grid>
        {event.customer_name && (
          <Grid.Row>
            <Grid.Column width={16}>
              <span>
                <FontAwesomeIcon icon={faUser} className="i-green mr-5" />
                {event.customer_name}
              </span>
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column width={4} className="signature-img-container">
            <img src={event.customer_signature} className="signature-img" alt="signature" />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};
